/**
 * `date` — measured, in monday's own order. `is only` and `is anything but` are offered by
 * monday and are **not** modelled: neither has a member in the public `ItemsQueryRuleOperator`
 * enum, so an integration cannot express them either (open question, `specs/M1-B6` §11).
 */
import { DATE_ROWS, IS_EMPTY, IS_NOT_EMPTY, condition, } from '../filter-conditions.js';
export const dateFilterConditions = [
    condition('is', 'any_of', 'date', { id: 'any_of' }),
    condition('is not', 'not_any_of', 'date', { id: 'not_any_of' }),
    ...DATE_ROWS,
    IS_EMPTY,
    IS_NOT_EMPTY,
];
//# sourceMappingURL=filters.js.map